import '../styles/MobileStyle.css';

function MobileIntervention() {
  return (
    <div className="container">
      <div className="text">
        Destroyer is a desktop-first app. Its drag and drop interface, perfect
        for idea generation, writing, and journaling, is best suited for larger
        screens.
      </div>
      <div className="footer">
        &#169; 2024 Mitch Gruen | &nbsp;
        <a className="mobile-link" href="mailto:mitchgruen.dev@gmail.com">
          mitchgruen.dev@gmail.com
        </a>
      </div>
    </div>
  );
}

export default MobileIntervention;
